








































































































































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import CalendarEvent, {EventRepeat, Months, WeekDays} from '@/modules/calendar/model/CalendarEvent'
import {Mutation, State} from 'vuex-class'
import DatePickerField from '@/components/DatePickerField.vue'
import CalendarEventType from '@/modules/calendar/model/CalendarEventType'
import {Colors, notify} from '@/modules/core/notification'

@Component({
    components: {DatePickerField},
})
export default class CalendarEventDetail extends Vue {
    public $refs: Vue['$refs'] & {
        form: {
            update: (field: string, value: any) => void,
            validate: () => boolean,
            valid: boolean,
        },
    }

    /**
     * Evento de calendario actualmente seleccionad por el usuario
     */
    @State(state => state.calendar.currentCalendarEvent)
    public event: CalendarEvent

    /**
     * Indica si el usuario esta creando un nuevo evento de calendario
     */
    @State(state => state.calendar.creatingCalendarEvent)
    public creating: boolean

    /**
     * Lista de tipos de eventos registrados
     */
    @State(state => state.calendar.calendarEventTypes)
    public eventTypes: CalendarEventType[]

    @Mutation('calendar/RESET_CALENDAR_EVENT_NONWORKING')
    public resetNonworking: () => void

    public eventRepeatOptions = [
        { text: 'Semanal', value: EventRepeat.Weekly },
        { text: 'Mensual', value: EventRepeat.Monthly },
        { text: 'Anual', value: EventRepeat.Annual },
        { text: 'Una vez', value: EventRepeat.Once },
    ]

    public weekDays = [
        { text: 'Lunes', value: WeekDays.Monday },
        { text: 'Martes', value: WeekDays.Tuesday },
        { text: 'Miércoles', value: WeekDays.Wednesday },
        { text: 'Jueves', value: WeekDays.Thursday },
        { text: 'Viernes', value: WeekDays.Friday },
        { text: 'Sábado', value: WeekDays.Saturday },
        { text: 'Domingo', value: WeekDays.Sunday },
    ]

    public get monthDays () {
        const days = _.range(1, 30).map(day => ({
            value: day,
            text: `Día ${day}`,
        }))

        days.push({value: 31, text: 'Último día del mes'})

        return days
    }

    public get months () {
        return Object.values(Months).slice(14).map((month) => {
            const date = new Date()
            date.setMonth(month as number - 1)

            return {
                text: date.toLocaleString('es-ES', { month: 'long' }),
                value: month,
            }
        })
    }

    public valid = true
    public saving = false

    public deleting = false
    public deleteConfirm = false

    public get rules () {
       return {
           name: [
               (v: string) => !!v || 'El nombre no puede estar vacío',
           ],
       }
    }

    /**
     * Genera un formato de fecha válido para el input de calendario
     */
    public get eventDate () {
        const date = this.event.date

        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    }

    public set eventDate (val: string) {
        this.$refs.form.update('date', new Date(val))
    }

    public get disabled () {
        return this.event.isNew && !this.creating
    }

    public get nonworking (): boolean {
        return this.event.isNonworking
    }


    public set nonworking (val: boolean) {
        this.$refs.form.update('isNonworking', val)
    }

    /**
     *  Get que permite obtener el resultado del campo festive.
     */
    public get festive (): boolean {
    return this.event.festive
    }

    /**
     * Set que permite introducir el valor en el campo festive.
     */
    public set festive (val: boolean) {
        this.$refs.form.update('festive', val)
    }

    /**
     * Guarda los cambios realizados al evento actualmente en edición.
     */
    public async save () {
        if (!this.$refs.form.validate()) {
            return
        }

        this.saving = true
        await this.$store.dispatch('calendar/saveCalendarEvent')

        notify(`El evento ${this.event.name} se ha guardado correctamente`)
        this.saving = false
    }

    /**
     * Captura cualquier error producido durante la ejecución del componente
     */
    public errorCaptured (error: Error) {
        notify(error.message, Colors.Error)
        this.saving = false
    }

    /**
     * Elimina el evento de calendario
     */
    public async remove () {
        this.deleting = true
        try {
            await this.$store.dispatch('calendar/deleteCalendarEvent')
        } catch (e) {
            notify(e.message, Colors.Error)

            return
        }

        this.deleting = false
        this.deleteConfirm = false
        notify('El evento se ha eliminado correctamente')
    }
}
